/**
 * StatusCell - Colored cell for remaining values (negative = red)
 */

import React from "react";
import { RemainingCell } from "../styled";

/**
 * Status cell for remaining values
 * @param {Object} props
 * @param {React.ReactNode} props.children - Cell content
 * @param {boolean} props.negative - Whether value is negative
 * @param {string} props.align - Text alignment
 */
const StatusCell = React.memo(({ children, negative, align = "right" }) => {
  return (
    <RemainingCell align={align} $negative={negative}>
      {children}
    </RemainingCell>
  );
});

StatusCell.displayName = "StatusCell";

export default StatusCell;
